/**
 * Get GQL iformation from window Object
 */
import { ILivedataDataCardsWidgetsConfig } from '@sky-it-livedata/livedata-data-cards-widgets';

interface IEndpointConfig extends ILivedataDataCardsWidgetsConfig {
  apikey: string;
}

export function isValidConfigurationObject(o: any): o is IEndpointConfig {
  return 'apikey' in o && 'endpoint' in o;
}

// @ts-ignore
export const getServiceConfiguration = () => {
  const configurationObject: IEndpointConfig =
    // @ts-ignore
    window?.SkyFoundationSettings?.LIVEDATA_FOOTBALL_SCORES;
  // window?.SkyFoundationSettings?.LIVEDATA_DATA_CARDS ?? window?.SkyFoundationSettings?.LIVEDATA_FOOTBALL_SCORES; // FIXME: for testing LMP and DATA-CARDS on same AEM page!
  if (isValidConfigurationObject(configurationObject)) {
    return configurationObject;
  } else {
    throw new Error(`invalid configuration object', ${configurationObject}`);
  }
};
